import { useNavigate } from "react-router-dom";
import { ArrowLeft, Heart, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function PageLayout({ title, children }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      // Clear localStorage and axios headers for Safari compatibility
      localStorage.removeItem('session_token');
      delete axios.defaults.headers.common['Authorization'];
      toast.success("Logged out successfully");
      navigate("/");
    } catch (error) {
      console.error("Logout failed", error);
      toast.error("Logout failed");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-amber-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Button
                data-testid="back-button"
                onClick={() => navigate("/dashboard")}
                variant="ghost"
                size="sm"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back
              </Button>
              <div className="flex items-center space-x-2">
                <Heart className="w-6 h-6 text-emerald-700" />
                <span className="text-lg font-bold text-gray-800">Soul Aid</span>
              </div>
            </div>
            <Button 
              data-testid="logout-button"
              onClick={handleLogout} 
              variant="ghost" 
              size="sm"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">{title}</h1>
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 mt-12">
        <div className="container mx-auto px-4">
          <p className="text-center text-sm text-gray-600">
            © 2024 Abject Ministries. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
